// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3zK0_","legacyBtn":"MutateMid_legacyBtn__2l3xM"};